import { AddressDto, BusinessCustomerDto } from '@/api/generated';
import {
  addressTranslation,
  CustomerStatusOptionsTranslation,
  customerStatusOptionsTranslation,
  CustomerTypeOptionsTranslation,
  customerTypeOptionsTranslation,
  FlagOptionsTranslation,
  flagOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type CustomerDetailsBusinessTranslation = {
  address: {
    fields: Record<keyof AddressDto, string>;
    title: string;
  };
  main: {
    fields: Record<keyof Omit<BusinessCustomerDto, 'address'>, string> & {
      flagOptions: FlagOptionsTranslation;
      statusOptions: CustomerStatusOptionsTranslation;
      typeOptions: CustomerTypeOptionsTranslation;
    };
    title: string;
  };
};

export const customerDetailsBusinessTranslation: CustomerDetailsBusinessTranslation = {
  address: {
    fields: addressTranslation,
    title: 'Dane adresowe',
  },
  main: {
    fields: {
      approvedAt: 'Data zatwierdzenia',
      approvedBy: 'Zatwierdził',
      customerId: 'ID klienta',
      flag: 'Flaga',
      flagOptions: flagOptionsTranslation,
      foundingDate: 'Data założenia',
      name: 'Nazwa klienta',
      nip: 'NIP',
      regon: 'Regon',
      rejectedAt: 'Data odrzucenia',
      rejectedBy: 'Odrzucił',
      rejectionReason: 'Powód odrzucenia',
      status: 'Status',
      statusOptions: customerStatusOptionsTranslation,
      type: 'Typ',
      typeOptions: customerTypeOptionsTranslation,
    },
    title: 'Dane klienta: {{clientName}}',
  },
};
